import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from "@angular/router";
import { AuthService } from '../auth/auth.service';
import { CanComponentDeactivate } from '../services/navigation-gaurd.service';
import { Observable } from 'rxjs';

declare function invokeFailToastr(title,message);
declare function invokeSuccessToastr(title,message);
declare var jQuery: any;
declare var $: any;

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: [  ]
})
export class LandingComponent implements OnInit, CanComponentDeactivate {

  

constructor(
  private _authService: AuthService,
   private readonly _router: Router) {
   }

canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
   return true;
   }
   ngOnInit() {
  }


}